"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmsImage = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Catch_1 = require("../../Catch");
var ImagePropsResolver_1 = require("./ImagePropsResolver");
function CmsImage(props) {
    return (React.createElement(Catch_1.Catch, { onError: props.onError, render: function () {
            var imagePropsResolver = new ImagePropsResolver_1.ImagePropsResolver(props);
            var imageProps = imagePropsResolver.resolve();
            return React.createElement("img", tslib_1.__assign({}, imageProps));
        } }));
}
exports.CmsImage = CmsImage;
//# sourceMappingURL=CmsImage.js.map